function processTokenError(tokenError) {
	if (tokenError && window.console && typeof window.console.error === 'function') {
		console.error(
			`Could not receive a social authorization token, proceeding without one`,
			tokenError
		);
	}
}

function getLocalStorageData(key) {
	try {
		if (!window.localStorage) {
			return {};
		}
	} catch (error) {
		//Local Storage is not accessible!
		return {};
	}

	const data = window.localStorage.getItem(key);
	const parsedData = JSON.parse(data) || {};

	if (parsedData.expire) {
		const now = new Date();

		if (now.getTime() > parsedData.expire) {
			window.localStorage.removeItem(key);

			return {};
		}

		return parsedData.value;
	}

	return parsedData;
}

export { processTokenError, getLocalStorageData };
